import { MatchConfigTypeToConfigKeyMap } from '@nova/configs';
import { EGameConfigs, IMatchConfigEntry, IMatchConfigEntryZr } from '@nova/types';

import { fetchCombatGameMatchConfigs } from './match-configs-fetch';

// TODO: Outpost Run entries are plain `IMatchConfigEntry` here; richer Tiled-side structs may merge later (config + map data siblings).

export class MatchConfigRepository {
  private _actionGameMatchConfigs?: MatchConfigTypeToConfigKeyMap;

  public constructor(actionGameMatchConfigs?: MatchConfigTypeToConfigKeyMap) {
    this._actionGameMatchConfigs = actionGameMatchConfigs;
  }

  public async init(gameAPIEndpoint: string): Promise<void> {
    if (this._actionGameMatchConfigs) { return; }
    this._actionGameMatchConfigs = await fetchCombatGameMatchConfigs(gameAPIEndpoint);
  }

  public getOrCopied(): IMatchConfigEntry[] {
    const orMatchConfigs = structuredClone(this._actionGameMatchConfigs?.[EGameConfigs.MATCH_CONFIGS_OR]);
    if (!orMatchConfigs?.length) {
      throw new Error(`this._actionGameMatchConfigs does not have any entries for key EGameConfigs.MATCH_CONFIGS_OR`);
    }

    return orMatchConfigs;
  }

  public findOrById(matchConfigId: string): IMatchConfigEntry | undefined {
    return this._actionGameMatchConfigs?.[EGameConfigs.MATCH_CONFIGS_OR].find(({ id }) => id === matchConfigId);
  }

  public findKnownOrById(matchConfigId: string): IMatchConfigEntry {
    const matchConfig = this._actionGameMatchConfigs?.[EGameConfigs.MATCH_CONFIGS_OR].find(({ id }) => id === matchConfigId);
    if (!matchConfig) { throw new Error(`Could not find match config <${matchConfigId}>`); }
    return matchConfig;
  }

  public getZrCopied(): IMatchConfigEntryZr[] {
    const zrMatchConfigs = structuredClone(this._actionGameMatchConfigs?.[EGameConfigs.MATCH_CONFIGS_ZR]);
    if (!zrMatchConfigs?.length) {
      throw new Error(`this._actionGameMatchConfigs does not have any entries for key EGameConfigs.MATCH_CONFIGS_ZR`);
    }

    return zrMatchConfigs;
  }

  public findZrById(matchConfigId: string): IMatchConfigEntryZr | undefined {
    return this._actionGameMatchConfigs?.[EGameConfigs.MATCH_CONFIGS_ZR].find(({ id }) => id === matchConfigId);
  }

  public getTfCopied(): IMatchConfigEntry[] {
    const tfMatchConfigs = structuredClone(this._actionGameMatchConfigs?.[EGameConfigs.MATCH_CONFIGS_TF]);
    if (!tfMatchConfigs?.length) {
      return [];
    }

    return tfMatchConfigs;
  }

  public findTfById(matchConfigId: string): IMatchConfigEntry | undefined {
    return this._actionGameMatchConfigs?.[EGameConfigs.MATCH_CONFIGS_TF]?.find(({ id }) => id === matchConfigId);
  }
}
